import { ButtonMain } from '@/modules/common/components/button';
import styles from './index.module.sass';
import wheatIcon from '@@/offer/images/grain.icon.svg';
import trashIcon from '@@/offer/images/trash.svg';
import { createSearchParams, Link, useNavigate } from 'react-router-dom';
import { IIncomingOffer } from '@/modules/offer/types/business-offer';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';
import { useStore } from 'effector-react';
import { numberToReadable } from '@/modules/common/helpers/number-to-readable.helper';
import { compareDateWithCurrentTime } from '@/modules/common/helpers/compare-date.helper';
import { spreadWheatType } from '@/modules/common/helpers/wheat-type.helper';
import classNames from 'classnames';
import { warehouseModel } from '@/entities/warehouse';
import { WarehouseTypes } from '@/modules/warehouses/ts';
import { useEffect, useState } from 'react';
import { PURCHASE_PRICE_WITHOUT_VAT } from '@/shared/constants/price.constants';

export const OfferContractItem = ({
  data,
  deleteFoo,
  isLast,
}: {
  data: IIncomingOffer;
  deleteFoo: (id: number, finallyFoo?: () => void) => Promise<void>;
  isLast: boolean;
}) => {
  const offerExpired =
    compareDateWithCurrentTime(data.expiration_date) === 'Не актуально';
  const agriculture = useStore($agriculture);
  const isWarehouseTypeSleeve =
    data?.warehouse_type &&
    (Number(data.warehouse_type) as unknown as WarehouseTypes) ===
      warehouseModel.WAREHOUSE_TYPES.sleeve;

  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState(
    compareDateWithCurrentTime(data.expiration_date),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const tLeft = compareDateWithCurrentTime(data.expiration_date);
      setTimeLeft(tLeft);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [data]);

  return (
    <div className={classNames(styles.root, offerExpired && styles.expired)}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <img src={wheatIcon} className={styles.wheatIcon} />
        </div>
        <div className={styles.info}>
          <h3 className={styles.title}>
            {agriculture.find((item) => item.id === data.agriculture_ids[0])?.name},{' '}
            {data.wheat_class}
          </h3>
          <span className={styles.subtitle}>
            {spreadWheatType(Number(data.wheat_type))?.sort}{' '}
            {spreadWheatType(Number(data.wheat_type))?.type}
          </span>
        </div>
        <div className={styles.weightAndCost}>
          <div className={styles.weight}>
            <span className={styles.label}>вес</span>
            <span className={styles.val}>
              {' '}
              {numberToReadable(Number(data.weight) + +data.weight_gain_tons || 0, 2)} т
            </span>
          </div>
          <div className={styles.cost}>
            <span className={styles.label}>стоимость</span>
            <span className={styles.val}>
              {numberToReadable(Number(data.price_netto) || 0)} ₽
            </span>
          </div>
        </div>
      </div>
      <div className={styles.labels}>
        <span
          //style={data.action === 'drain' ? { backgroundColor: '#FFEAEB' } : undefined}
          className={styles.labelMix}
        >
          {data.action === 'mix' ? (
            <>
              <span className={styles.tag}>миксование</span>

              <Link
                to={
                  Array.isArray(data.bunkerreloaders_ids) &&
                  data.bunkerreloaders_ids.length > 0
                    ? `/mixing/recipe/detail/${data.mix_id}?warehouse_id=${
                        data.warehouse_id
                      }&bunker=${JSON.stringify(
                        data.bunkerreloaders_ids,
                      )}&viewOnly=true`
                    : `/mixing/mixer/${data.mix_id}?viewOnly=true`
                }
                className={styles.showRecipeAction}
              >
                показать рецепт
              </Link>
              <span className={styles.wh}> {data.warehouse_name}</span>
            </>
          ) : data.action === 'hydrate' ||
            data.action === 'drain' ||
            data.action === null ? (
            <div className={styles.actionNID}>
              <span
                style={
                  data.action === 'drain'
                    ? { backgroundColor: 'rgb(255, 234, 235)' }
                    : data.action === null
                    ? { opacity: 0 }
                    : {}
                }
                className={styles.tag}
              >
                {data.action === 'drain'
                  ? 'осушение'
                  : data.action === 'hydrate'
                  ? 'увлажнние'
                  : ''}
              </span>
              <div className={styles.sleeve}>
                <span>{data.warehouse_name}</span>
                <b>{`${isWarehouseTypeSleeve ? 'рукав' : 'объём'} ${
                  data?.items?.[0].bag_id
                }`}</b>
              </div>
            </div>
          ) : (
            ''
          )}
        </span>
      </div>
      <div className={styles.details}>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>клейковина</span>
          <span className={styles.detailValue}>
            {numberToReadable(Number(data.gluten) || 0, 1)} <b>%</b>
          </span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>влажность</span>
          <span className={styles.detailValue}>
            {numberToReadable(Number(data.humidity) || 0, 1)} <b>%</b>
          </span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>ИДК</span>
          <span className={styles.detailValue}>
            {numberToReadable(Number(data.idk) || 0, 1)}
          </span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>натура</span>
          <span className={styles.detailValue}>
            {numberToReadable(Number(data.nature) || 0, 1)} <b>г/л</b>
          </span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>число падения</span>
          <span className={styles.detailValue}>
            {numberToReadable(Number(data.cp) || 0, 1)} <b>сек</b>
          </span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.detailLabel}>протеин</span>
          <span className={styles.detailValue}>
            {numberToReadable(Number(data.protein) || 0, 1)} <b>%</b>
          </span>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.timeAndPrice}>
          <div className={styles.detail}>
            <span className={styles.label}>срок предложения</span>
            <span
              className={classNames(styles.val, offerExpired && styles.expiredDate)}
            >
              {timeLeft}
            </span>
          </div>
          <div className={styles.detail}>
            <span className={styles.label}>{PURCHASE_PRICE_WITHOUT_VAT}</span>
            <span className={styles.val}>
              {numberToReadable(Number(data.price) || 0)} ₽/т
            </span>
          </div>
        </div>
        <div className={styles.actions}>
          {data.destination_id ? (
            <ButtonMain
              label="логистика"
              onClick={() => {
                navigate({
                  pathname: '/mixing/logistics/management',
                  search: createSearchParams({
                    trade_id: String(data.id),
                    destination_id: String(data.destination_id),
                    warehouse_id: String(data.warehouse_id),
                    back_url: `/offer/contracts/${data.buyerable_id}?buyerable_id=${data.buyerable_id}&buyerable_type=${data.buyerable_type}`,
                  }).toString(),
                });
              }}
              className={styles.logisticsButton}
            />
          ) : (
            <span className={styles.pickup}>самовывоз</span>
          )}
          <a
            href="#"
            onClick={async (e) => {
              e.preventDefault();
              await deleteFoo(data.id, () => {
                isLast && navigate('/offer/contracts');
              });
            }}
            className={styles.deleteButton}
          >
            <img src={trashIcon} className={styles.icon} /> удалить позицию
          </a>
        </div>
      </div>
    </div>
  );
};
